import { render } from "./Logo.vue?vue&type=template&id=6e2efd0e"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Developer\\Desktop\\Company\\help-desk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__